import React, {Component} from 'react'

import SettingsGroup from '../../../struct/SettingsGroup'
import Field from '../../../struct/Field'
import InputText from 'lib/struct/form/InputText'
import Select from '../../../control/DependentSelect'
import Hint from '../../../struct/Hint'

import ProfileCatalogStocksSelect from './ProfileCatalogStocksSelect'
import Radio from 'lib/struct/form/Radio'

import styles from './ShopSettings.less'
import CampaignConditions from './CampaignConditions'
import ConditionsContext from '../../../../context/ConditionsContext'
import * as SelectionMode from '../../../../constant/ProfileCatalogSelectionMode'
import ProfileCatalogEntitiesSelect from './ProfileCatalogEntitiesSelect';
import NestedField from '../../../struct/NestedField'
import Button from 'lib/control/Button';
import TagSourceField from '../../../struct/TagSourceField'
import OfferFieldValueSourceSelect from '../../../struct/OfferFieldValueSourceSelect'
import OfferFieldsMarkupsField from '../../../struct/OfferFieldsMarkupsField'
import Checkbox from 'lib/control/Checkbox'
import Iconui from 'lib/struct/iconui/Iconui';

const StockSelectionOptions = [{
    label: 'Все склады',
    value: 'ALL',
}, {
    label: 'Выбрать...',
    value: 'SELECTED_STOCKS',
}]

const OrderContactOptions = [{
    label: 'По умолчанию',
    value: 'default',
}, {
    label: 'Указать',
    value: 'custom',
}]

const PricesOptions = [{
    label: 'из админ-панели',
    value: 'shopscript',
}, {
    label: 'из маркетплейса, с учетом скидок',
    value: 'ymarket_subsidy',
}, {
    label: 'из маркетплейса, не учитывать скидки',
    value: 'ymarket',
}]

const StickerOptions = [{
    label: 'A9 горизонтально (58 × 40 мм)',
    value: 'A9_HORIZONTALLY'
}, {
    label: 'А9 (40 × 58 мм)',
    value: 'A9'
}, {
    label: 'А7 (120 × 75 мм)',
    value: 'A7'
}, {
    label: 'A4 (9,1 × 70,6 мм)',
    value: 'A4'
}]

export default class CatalogSettings extends Component {
    constructor(props) {
        super(props)
        const use_selected_stock_for_order = props.campaign.use_selected_stock_for_order ? props.campaign.use_selected_stock_for_order : false
        const comment_disabled = props.campaign.comment_disabled ? props.campaign.comment_disabled : false
        const yandex_id_in_comment = props.campaign.yandex_id_in_comment ? props.campaign.yandex_id_in_comment : false
        const shipping_date_in_comment = props.campaign.shipping_date_in_comment ? props.campaign.shipping_date_in_comment : false
        props.campaign.ya_api_token = props.campaign.ya_api_token ? props.campaign.ya_api_token :
            props.settings.ya_api_token ? props.settings.ya_api_token : ''
        this.state = {
            synchronized_at: props.campaign.synchronized_at,
            price_synchronized_at: props.campaign.price_synchronized_at,
            orders_synchronized_at: props.campaign.orders_synchronized_at,
            selected_stock_option: props.campaign.selected_stock_option,
            include_unavailable_products: props.campaign.include_unavailable_products,
            include_hidden_products: props.campaign.include_hidden_products,
            use_selected_stock_for_order: use_selected_stock_for_order,
            catalog_selection_mode: props.campaign.catalog_selection_mode,
            general_prices: props.campaign.general_prices,
	        conditions: this.props.context.conditions,
	        campaign: null,
            updateMessage: '',
            priceUpdateMessage: '',
            total_prices : 0,
            order_contact_option: props.campaign.order_contact_option,
            order_contact_id: props.campaign.order_contact_id,
            sales_channel: props.campaign.sales_channel,
            prices_option: props.campaign.prices_option,
            shipping_id: props.campaign.shipping_id,
            payment_id: props.campaign.payment_id,
            comment_disabled: comment_disabled,
            yandex_id_in_comment: yandex_id_in_comment,
            shipping_date_in_comment: shipping_date_in_comment,
            sticker_format: props.campaign.sticker_format,
        }
    }

    changeFieldValue = (fieldName, value) => {
        this.setState({[fieldName]: value})
        this.props.campaign[fieldName] = value
    }

		componentWillMount = () => {
			this.setCampaignCondition();
		}

		componentWillReceiveProps = () => {
				this.setCampaignCondition();
		}

		changeConditions = (conditions) => {
			this.setState({conditions})
			this.props.context.conditions = conditions
			this.setCampaignCondition();
		}

		setCampaignCondition = () => {
			/** @type {CampaignSettings} */
			const campaign = this.props.campaign
			if (this.props.context.conditions) {
				const conditions = []
				for (const condition of this.props.context.conditions) {
					if (+condition.campaign_id === +campaign.id) {
						conditions.push(condition)
					}
				}
				campaign.condition = new ConditionsContext(conditions)
			}

			campaign.cli_command = campaign.cli_command ? campaign.cli_command : 'php'
			campaign.synchronized_at = campaign.synchronized_at ? campaign.synchronized_at : '00.00.00 00:00'
			campaign.username = campaign.username ? campaign.username : 'root'

			this.setState({campaign})
		}

    getBusinessId = (checked) => {
        this.changeFieldValue('general_prices', checked)

        if(!checked) {
            return false
        }
        const url ='?plugin=pokupki&action=getBusinessId'

        $.ajax({
            url: url,
            method: 'POST',
            dataType: 'json',
            data: {campaign_id: this.state.campaign.id}
        }).then(
            response => {
                this.props.campaign.business_id = response.data.business_id
                this.setState({campaign:this.props.campaign})
            },() => {
                console.log('Error')
            }
        );
    }

    step_interval_id = null;
    $icon = null;

    synchronize = (price = false) => {
        if (!(price === true) && !this.state.campaign.yamarket_stock_id){
            alert("Заполните номер склада Я.Маркет")
            return
        }

        if (this.state.campaign.auth_method == 'api_key' && !this.state.campaign.api_key) {
            alert("Заполните ApiKey")
            return
        }

        if (this.state.campaign.auth_method == 'oauth' && !this.state.campaign.ya_api_token) {
            alert("Заполните исходящий токен")
            return
        }

        if (price) {
            $('.'+styles['warning-limit-prices']).hide();
        }

        this.setState({
            updateMessage: ''
        })

        const url = price === true ? '?plugin=pokupki&action=orderPrices':'?plugin=pokupki&action=orderStocks'

        this.$icon = price === true ? $('.'+styles['sync-status-prices']+ ' i') : $('.'+styles['sync-status']+ ' i')
        this.$icon.removeClass('yes').addClass('loading')
        this.$icon.show()
        $.ajax({
            url: url,
            method: 'POST',
            dataType: 'json',
            data: {campaign: JSON.parse(JSON.stringify(this.state.campaign))}
        }).then(
            response => {
                this.setState({
                    process_data: response
                });

                if(price && parseInt(response.skus_count) > 500) {
                    this.setState({
                        total_prices:parseInt(response.skus_count)
                    })
                    $('.'+styles['warning-limit-prices']).show();
                }

                if(parseInt(response.skus_count) > 0) {
                    this.step_interval_id = setInterval(() => {this.stepSynch(url)}, 5000)
                } else {
                    this.doneSynch(response)
                }
            },() => {
                console.log('Error')
            }
        );
    }

    count_step_requests = 0;

    stepSynch = (url) => {
        if (this.count_step_requests >= 2) {
            return;
        }

        $.ajax({
            url: url,
            cache: false,
            method: 'POST',
            data: {
                campaign: JSON.parse(JSON.stringify(this.state.campaign)),
                processId: this.state.process_data.processId
            },
            dataType: 'json'
        }).then(response => {
            this.count_step_requests--;

            if (response.ready || response.state === 'error') {
                this.doneSynch(response);
                return;
            }

            this.setState({
                process_data: response
            });
        }, () => {
            this.count_step_requests--;
            this.doneSynch({state: 'error'});
            return;
        });

        this.count_step_requests++;
    };

    doneSynch = (response) => {
        clearInterval(this.step_interval_id);
        if(response.state === 'error') {
            this.$icon.removeClass('loading').addClass('no');

            if(response.price) {
                this.setState({
                    priceUpdateMessage: 'Ошибка обновления (подробнее в логах)'
                })
            } else {
                this.setState({
                    updateMessage: 'Ошибка обновления (подробнее в логах)'
                })
            }
            return;
        }
        if(parseInt(response.skus_count) > 0) {
            this.$icon.removeClass('loading').addClass('yes');
            // setTimeout(() => this.$icon.removeClass('yes').addClass('loading').hide(), 1000)
            if(response.price) {
                this.setState({
                    priceUpdateMessage: 'Обновлено товаров: ' + response.updated_offers
                })
                this.changeFieldValue('price_synchronized_at', response.updatedAt)
            } else {
                this.setState({
                    updateMessage: 'Обновлено товаров: ' + response.skus_count
                })
                this.changeFieldValue('synchronized_at', response.updatedAt)
            }
        } else {
            this.$icon.removeClass('loading').addClass('no');
            // setTimeout(() => this.$icon.removeClass('yes').addClass('loading').hide(), 1000)
            if(response.price) {
                this.setState({
                    priceUpdateMessage: 'Нет цен для обновления'
                })
            } else {
                this.setState({
                    updateMessage: 'Нет остатков для обновления'
                })
            }
        }
    };

    render() {
        const campaign = this.state.campaign
        const {context} = this.props


        const with_categories = context.categories.length
        const with_sets = context.sets.length
        const with_types = context.product_types.length

        const offerFields = campaign.prices
        const offerFieldsKeys = Object.keys(offerFields)
        const DBS = campaign.type === 'DBS'
        const fbs = campaign.type === 'FBS'
        const fbsx = campaign.type === 'FBSX'
        const suffix = campaign.type === 'FBSX' ? 'FBS express' : campaign.type
        campaign.sales_channel = campaign.sales_channel ? campaign.sales_channel : 'Я.Марект (' + suffix + ')'

        return (
            <div>
                <SettingsGroup title={'2. Выбор товаров'} className={styles['settings-block']}>
                    <Hint className={styles['hintHeader']}>{'Все процессы, связанные с определением наличия и обновлением цен будут учитывать только те товары, которые выбраны в этом пункте.'}</Hint>
                    <Field label="Выбрать товары">
                        {
                            with_categories || with_sets || with_types ? (
                                <NestedField>
                                    <Select
                                        className={styles["selection-mode__select"]}
                                        wrapperClassName={styles["selection-mode__wrapper"]}
                                        options={SelectionMode.control_options}
                                        value={this.state.catalog_selection_mode}
                                        onChange={e => this.changeFieldValue('catalog_selection_mode', e.target.value)}
                                        state={context.form_state}
                                    />

                                    {
                                        this.state.catalog_selection_mode === SelectionMode.SELECTED_ENTITIES ? (
                                            <ProfileCatalogEntitiesSelect context={context} campaign={campaign}/>
                                        ) : (null)
                                    }
                                </NestedField>
                            ) : (null)
                        }
                    </Field>
                    <Field label="Выбрать склады">
                        <NestedField>
                            <Select
                                options={StockSelectionOptions}
                                value={this.state.selected_stock_option}
                                onChange={e => this.changeFieldValue('selected_stock_option', e.target.value)}
                                state={context.form_state}
                            />

                            {
                                this.state.selected_stock_option === 'SELECTED_STOCKS' ? (
                                    <ProfileCatalogStocksSelect context={context} campaign={campaign}/>
                                ) : (null)
                            }

                            <Hint>Наличие и остаток товаров будет определятся по выбранным складам.</Hint>
                        </NestedField>
                    </Field>
                    <Field label="При получении заказа списывать с этих же складов" className={styles['select-field']} fieldClass={styles['select-field-box']}>
                        <Checkbox
                            checked={this.state.use_selected_stock_for_order}
                            onChange={e => this.changeFieldValue('use_selected_stock_for_order', e.target.checked)}
                        >
                        </Checkbox>
                    </Field>
                    <Field label="Учитывать cкрытые товары" className={styles['select-field']} fieldClass={styles['select-field-box']}>
                        <Checkbox
                            checked={this.state.include_hidden_products}
                            onChange={e => this.changeFieldValue('include_hidden_products', e.target.checked)}
                        >
                        </Checkbox>
                    </Field>
                    <Field label="Учитывать недоступные для заказа" className={styles['select-field']} fieldClass={styles['select-field-box']}>
                        <Checkbox
                            checked={this.state.include_unavailable_products}
                            onChange={e => this.changeFieldValue('include_unavailable_products', e.target.checked)}
                        >
                        </Checkbox>
                    </Field>
                </SettingsGroup>
                <SettingsGroup title={'3. Передача остатков'} className={styles['settings-block']}>
                    <Hint className={styles['hintHeader']}>{'Обновление остатков через API-интерфейс для товаров, выбранных в разделе №2'}</Hint>
                    <CampaignConditions context={this.props.context} changeConditions={this.changeConditions} compaign={this.props.campaign}/>

                    <Field label="Номер склада в Яндекс.Маркет">
                        <InputText
                            defaultValue={campaign.yamarket_stock_id}
                            onChange={e => campaign.yamarket_stock_id = e.target.value}
                            disabled={false}
                            readOnly={false}
                            placeholder={'0000000000000'}
                        />
                        <Hint>{'Его можно взять в личном кабинете Яндекс.Маркет: левое меню, "Логистика" - "Склады"'}</Hint>
                    </Field>
                    <Field label="Отправка остатков">
                        { campaign.cli_command !== 'php' ? (
                            <div>
                                <p>Для автоматического обновления остатков нужно добавить команду в crontab пользователя <strong>{campaign.username}</strong></p>
                                <InputText
                                    defaultValue={campaign.cli_command}
                                    onClick={(e) => {
                                        e.target.select()
                                    }}
                                    disabled={false}
                                    readOnly={true}
                                    placeholder={''}
                                    style={{color: '#777777', backgroundColor: '#eeeeee', border: '1px solid #eeeeee', width: '100%'}}
                                />
                                <Hint>Дата последнего запуска: {this.state.synchronized_at}</Hint>
                                <Button
                                    className={'button'}
                                    onClick={this.synchronize}
                                >Обновить сейчас</Button>
                                <span className={styles['sync-status']}>
                                    <Iconui name="loading" style={{display: 'none'}} />
                                    <span>{this.state.updateMessage}</span>
                                </span>
                            </div>
                            ) : (<p>Команда для обновления будет доступна после сохранения профиля</p>)
                        }
                    </Field>
                </SettingsGroup>
                <div className={styles['instruction']}>
                    В случае возникновения проблем, пожалуйста, обратитесь к <a target="_blank" href="https://bodysite.ru/help/1975/diagnostika-raboty-plagina-integratsiya-s-yandeksmarket/#stocks">инструкции по диагностике передачи остатков</a>
                </div>
                <SettingsGroup title={'4. Передача цен'} className={styles['settings-block']}>
                    <Hint className={styles['hintHeader']}>{'Обновление цен через API-интерфейс для товаров, выбранных в разделе №2'}</Hint>
                    <Field label="Обновлять базовые цены (для всего кабинета)">
                        <Checkbox
                            checked={this.state.general_prices}
                            onChange={e => this.getBusinessId(e.target.checked)}
                        >
                        </Checkbox>
                    </Field>
                    {(offerFieldsKeys.map((key) => {
                            /** @type {Field} */
                            const field = offerFields[key]
                            if (!field.isConditionsMet()) {
                                return null
                            }

                            field.markups = field.markups ? field.markups : []
                            const hint = key=='price' ? field.hint : 'Цена до скидки'
                            return (
                                <div key={key}>
                                    <TagSourceField
                                        label={field.name}
                                        tag={field.tag}
                                        hint={hint}
                                        key={key}
                                        indent_label={field.parent}
                                        type={field.type}
                                        required={key=='price'}
                                        profile={campaign}
                                        field={field}
                                    >
                                        <OfferFieldValueSourceSelect
                                            context={context}
                                            value_source={field.value}
                                            field={field.dataset}
                                            fieldObject={field}
                                        />
                                    </TagSourceField>
                                    {field.markups && <OfferFieldsMarkupsField
                                        context={context}
                                        field={field}
                                        profile={campaign}
                                        markups={field.markups}
                                        label={'Наценка'}
                                        indent_label={true}
                                    />}
                                </div>)
                        }
                    ))}
                    {(<Field label="Отправка цен">
                        { campaign.price_cli_command !== 'php' ? (
                            <div>
                                <p>Для автоматического обновления цен нужно добавить команду в crontab пользователя <strong>{campaign.username}</strong></p>
                                <InputText
                                    defaultValue={campaign.price_cli_command}
                                    onClick={(e) => {
                                        e.target.select()
                                    }}
                                    disabled={false}
                                    readOnly={true}
                                    placeholder={''}
                                    style={{color: '#777777', backgroundColor: '#eeeeee', border: '1px solid #eeeeee', width: '100%'}}
                                />
                                <Hint>Дата последнего запуска: {this.state.price_synchronized_at}</Hint>
                                <Button
                                    className={'button'}
                                    onClick={(e) => {this.synchronize(true)}}
                                >Обновить сейчас</Button>
                                <span className={styles['sync-status-prices']}>
                                    <Iconui name="loading" style={{display: 'none'}} />
                                    <span>{this.state.priceUpdateMessage}</span>
                                </span>
                                <div className={styles['warning-limit-prices']}>
                                    {'Товаров: '+ this.state.total_prices +'. Корректное обновление при ручном запуске не гарантируется из-за лимитов API. Запустите CRON команду\n' +
                                    '\n'}
                                </div>
                                <div className={styles['limit-prices']}>
                                    Лимиты API Яндекс.Маркета: до 500 товаров в минуту
                                </div>
                            </div>
                        ) : (<p>Команда для обновления будет доступна после сохранения профиля</p>)
                        }
                    </Field>)}

                </SettingsGroup>
                <div className={styles['instruction']}>
                    В случае возникновения проблем, пожалуйста, обратитесь к <a target="_blank" href="https://bodysite.ru/help/1975/diagnostika-raboty-plagina-integratsiya-s-yandeksmarket/#price">инструкции по диагностике передачи цен</a>
                </div>
                <SettingsGroup title={'5. Заказы'} className={styles['settings-block']}>
                    {((fbsx || fbs) && <Field label="Контакт в заказе" fieldClass={styles['select-field-box']}>
                        <Select
                            options={OrderContactOptions}
                            value={this.state.order_contact_option}
                            onChange={e => this.changeFieldValue('order_contact_option', e.target.value)}
                            state={context.form_state}
                        />
                        <Hint>{'Все заказы из Яндекс.Маркет создаются на один контакт.'}</Hint>
                    </Field>)}
                    {( (fbsx || fbs) && this.state.order_contact_option === 'custom' && <Field label="ID контакта">
                            <InputText
                                defaultValue={campaign.order_contact_id}
                                onChange={e => campaign.order_contact_id = e.target.value}
                                disabled={false}
                                readOnly={false}
                                placeholder={'012345'}
                            />
                        </Field>
                    )}
                    <Field label="Канал продаж">
                        <InputText
                            defaultValue={campaign.sales_channel}
                            onChange={e => campaign.sales_channel = e.target.value}
                            disabled={false}
                            readOnly={false}
                            placeholder={'Я.Маркет ('+campaign.type+')'}
                        />
                        <Hint>{'В данном поле вы можете заполнить название для канала продаж, который будет отображаться в общем списке заказов. По нему удобно фильтровать заказы.'}</Hint>
                    </Field>
                    {((fbsx || fbs) && <Field label="Название склада отгрузки">
                            <InputText
                                defaultValue={campaign.delivery_stock}
                                onChange={e => campaign.delivery_stock = e.target.value}
                                disabled={false}
                                readOnly={false}
                                placeholder={'ПВЗ на Ленина'}
                            />
                            <Hint>{'Не обязательно. Произвольное название места отгрузки для этого магазина, будет отображаться в информационном блоке заказа'}</Hint>
                        </Field>
                    )}
                    <Field label="Указывать в заказе цены:" className={styles['select-field']} fieldClass={styles['select-field-box']}>
                        <Select
                            options={PricesOptions}
                            value={this.state.prices_option}
                            onChange={e => this.changeFieldValue('prices_option', e.target.value)}
                            state={context.form_state}
                        />
                    </Field>
                    {((fbs || fbsx) &&  <Field label="Способ доставки, который будет выбран в заказе:" className={styles['select-field']} fieldClass={styles['select-field-box']}>
                        <Select
                            options={context.delivery_methods}
                            value={this.state.shipping_id}
                            onChange={e => this.changeFieldValue('shipping_id', e.target.value)}
                            state={context.form_state}
                        />
                    </Field>)}
                    {((fbsx || fbs) &&  <Field label="Способ оплаты, который будет выбран в заказе:" className={styles['select-field']} fieldClass={styles['select-field-box']}>
                        <Select
                            options={context.shop_payment_methods}
                            value={this.state.payment_id}
                            onChange={e => this.changeFieldValue('payment_id', e.target.value)}
                            state={context.form_state}
                        />
                    </Field>)}
                    {((fbsx || fbs) &&  <Field label="Не добавлять комментарий клиента в заказ:" className={styles['select-field']} fieldClass={styles['select-field-box']}>
                        <Checkbox
                            checked={this.state.comment_disabled}
                            onChange={e => this.changeFieldValue('comment_disabled', e.target.checked)}
                        >
                        </Checkbox>
                    </Field>)}
                    <Field label="Добавить номер заказа в комментарий:" className={styles['select-field']} fieldClass={styles['select-field-box']}>
                        <Checkbox
                            checked={this.state.yandex_id_in_comment}
                            onChange={e => this.changeFieldValue('yandex_id_in_comment', e.target.checked)}
                        >
                        </Checkbox>
                    </Field>
                    <Field label="Добавить дату отгрузки в комментарий:" className={styles['select-field']} fieldClass={styles['select-field-box']}>
                        <Checkbox
                            checked={this.state.shipping_date_in_comment}
                            onChange={e => this.changeFieldValue('shipping_date_in_comment', e.target.checked)}
                        >
                        </Checkbox>
                    </Field>
                    <Field label="Формат наклеек:" className={styles['select-field']} fieldClass={styles['select-field-box']}>
                        <Select
                            options={StickerOptions}
                            value={this.state.sticker_format}
                            onChange={e => this.changeFieldValue('sticker_format', e.target.value)}
                            state={context.form_state}
                        />
                    </Field>
                    { campaign.cli_command_orders !== 'php' ? (
                        <div>
                            <p>Яндекс.Маркет сам присылает запросы в магазин при различных действиях с заказами. Однако, если встречаются проблемы с актуальностью обновления статусов, вы можете включить самостоятельный запрос информации о заказах</p>
                            <InputText
                                defaultValue={campaign.cli_command_orders}
                                onClick={(e) => {
                                    e.target.select()
                                }}
                                disabled={false}
                                readOnly={true}
                                placeholder={''}
                                style={{color: '#777777', backgroundColor: '#eeeeee', border: '1px solid #eeeeee', width: '100%'}}
                            />
                            <Hint>Дата последнего запуска: {this.state.orders_synchronized_at}</Hint>
                        </div>
                    ) : (<p>Команда для обновления будет доступна после сохранения профиля</p>)}
                </SettingsGroup>
                <div className={styles['instruction']}>
                    В случае возникновения проблем, пожалуйста, обратитесь к <a target="_blank" href="https://bodysite.ru/help/1975/diagnostika-raboty-plagina-integratsiya-s-yandeksmarket/#accept">инструкции по диагностике передачи заказов</a>
                </div>
            </div>
        )
    }
}
